import { ProductDetailViewEvent, ProductDetailViewEventFku } from '@/usecases/event-bus-for-third-party/events/product-detail'

/**
 * MyColor独自: GladCube P-MAX広告配信用イベント
 *
 * @see https://my-color.esa.io/posts/1256
 */
export function handleProductDetailViewEvent(event: ProductDetailViewEvent): void {
  const products = event.fku.reduce(
    (acc: GradCubeProductItem[], fku: ProductDetailViewEventFku): GradCubeProductItem[] => [
      ...acc,
      ...fku.sku.map(sku => ({
        sku_number: sku.sku_number,
        price: sku.price,
      })),
    ],
    []
  )

  window.dataLayer.push({
    event: 'smb_item_detail_view',
    products,
  })
}

interface GradCubeProductItem {
  sku_number: string
  price: number
}
